import { Button } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import styled from 'styled-components';
import Background from 'ui/atoms/Background/Background';
import Typography from 'ui/atoms/Typography/Typography';
import ComponentWrapper from '../ComponentWrapper/ComponentWrapper';

const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  gap: 2rem;

  span {
    color: ${({ theme }) => theme.colors.primary};
    ${({ theme }) => theme.typography.variant('title1')}
  }
`;

export interface Props {
  handleButtonOnClick: () => void;
}

const WelcomePage: React.FC<React.PropsWithChildren<Props>> = ({ handleButtonOnClick }) => {
  const { translation } = useTranslation();

  return (
    <>
      <Background id="background" />
      <Wrapper>
        <ComponentWrapper gap="0.5rem">
          <Typography variant="title1">{translation.welcome_to_atlas}</Typography>
        </ComponentWrapper>
        <ComponentWrapper width="14.5rem" alignSelf="center">
          <Button onClick={handleButtonOnClick} variant="contained" size="large" color="primary" fullWidth>
            Start setup
          </Button>
        </ComponentWrapper>
      </Wrapper>
    </>
  );
};

export default WelcomePage;
